import React, { useState } from 'react';
import Close from 'components/common/Close/Close';
import { white, black40 } from 'styles/common/_constants.scss';
import { useClickOutside, useIsMobile, useToast } from 'hooks';
import Button from 'components/common/Button/Button';
import { func, string } from 'prop-types';
import VidoeAdService from 'services/videoAds';
import AdService from 'services/adService';

const DeleteAd = ({ hide, currentId, adtype, type, celebrityId, handleApiCall, id }) => {
  const isMobile = useIsMobile();
  const ref = useClickOutside(hide);
  const { showToast, showErrorToast } = useToast();
  const [loading, setLoading] = useState(false);

  const onDeleteSuccess = () => {
    hide();
    setLoading(false);
    showToast(`Delete ${type} ad successfully!`);
    handleApiCall();
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      if (adtype === 'video') {
        if (type === 'Shorts') {
          await VidoeAdService.deleteNarrativeIndivualvideoAd(celebrityId, id, currentId);
        } else if (type === 'Movies & Series') {
          await VidoeAdService.deleteSeriesIndivualvideoAd(celebrityId, id, currentId);
        }
      } else if (adtype === 'widget') {
        if (type === 'Shorts') {
          await AdService.deleteNarrativeIndivualwidgetAd(celebrityId, id, currentId);
        } else if (type === 'Movies & Series') {
          await AdService.deleteSeriesIndivualwidgetAd(celebrityId, id, currentId);
        }
      } else if (adtype === 'banner') {
        if (type === 'Shorts') {
          await AdService.deleteNarrativeIndivualbannertAd(celebrityId, id, currentId);
        } else if (type === 'Movies & Series') {
          await AdService.deleteSeriesIndivualbannerAd(celebrityId, id, currentId);
        }
      }
      onDeleteSuccess();
    } catch ({ responses }) {
      setLoading(false);
      throw showErrorToast(responses);
    }
  };

  return (
    <div className="delete-modal" ref={ref}>
      <div className="delete-modal-header">
        {`Delete ${type} ad`}
        <Close onClick={hide} color={isMobile ? white : black40} />
      </div>
      <div className="layer delete-modal-header-content">
        <div className="delete-content-div">
          <span>Are you sure you want to delete your ad?</span>
          <div className="buttons">
            <Button className="cancel-btn" onClick={hide}>
              Cancel
            </Button>
            <Button
              type="primary"
              labelId="Yes, delete"
              className="delete-btn"
              onClick={handleSubmit}
              disabled={loading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

DeleteAd.propTypes = {
  hide: func.isRequired,
  currentId: string,
  celebrityId: string,
  type: string,
  handleApiCall: func
};

export default DeleteAd;
